<template>
    <ul class="full-width-edit-material" v-loading="loading">
        <li>
            <div class="input-label">
                <span tkey="中文名稱">{{i18n.tkey("lang_cn_name")}}</span>
            </div>

            <div>
                <el-input
                        v-model="paymentTitle"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="100"
                />
            </div>
        </li>

        <li>
            <div class="input-label">
                <span tkey="英文名稱">{{i18n.tkey("lang_en_name")}}</span>
            </div>

            <div>
                <el-input
                        v-model="paymentSubTitle"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="100"
                />
            </div>
        </li>

        <li>
            <div class="input-label">
                <span tkey="備註">{{i18n.tkey("lang_notes")}}</span>
            </div>

            <div>
                <el-input
                        v-model="sremark"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="100"
                />
            </div>
        </li>

        <li>
            <div class="input-label">
                <span tkey="付款方式">{{i18n.tkey("lang_paymentmethod")}}</span>
            </div>

            <div>
                <el-select v-model="paymentMethod" :placeholder="i18n.tkey('lang_select_payment_alert')" size="large">
                    <el-option
                            v-for="n in selectOptionList"
                            :key="n"
                            :label="n"
                            :value="n"
                    />
                </el-select>
            </div>
        </li>

        <li>
            <div class="input-label">
                <span tkey="收款賬號">{{i18n.tkey("lang_revice_account")}}</span>
            </div>

            <div>
                <el-input
                        v-model="accountLogin"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="100"
                />
            </div>
        </li>
      <li>
        <div class="input-label">
          <span tkey="收款賬號key/token">{{i18n.tkey("lang_revice_account")}}Token</span>
        </div>

        <div>
          <el-input
              v-model="accountPassword"
              placeholder=""
              clearable
              show-word-limit
              maxlength="100"
          />
        </div>
      </li>

        <li>
            <div class="input-label">
                <span tkey="手續費(百分比)">{{i18n.tkey("lang_commission_per")}}</span>
            </div>

            <div>
                <el-input
                        type="number"
                        v-model="handlePercent"
                        min="0"
                        placeholder=""
                        clearable
                />
            </div>
        </li>

        <li>
            <div class="input-label">
                <span tkey="圖片">{{i18n.tkey("lang_img")}}</span>
            </div>

            <div>
                <uploadImg v-model="QRImg" :width="150" :height="150" />
            </div>
        </li>

        <li style="text-align: center">
            <el-button type="primary" @click="insertClick" v-if="null == obj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
            <el-button type="primary" @click="updateClick" v-if="null != obj" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </li>
    </ul>
</template>

<script setup>
    import {getCurrentInstance, inject, onMounted, ref, toRef} from "vue";
    import myUtil from "@/util/util"
    import uploadImg from "@/components/shopopee/form/uploadImg"
    import {useUserinfo} from "@/stores/userinfo";
    import eshopopeeApi from "@/request/eshopopeeApi";

    const { proxy } = getCurrentInstance()

    const userInfoRef = toRef(useUserinfo())

    const props = defineProps(['obj'])
    const emit = defineEmits(['uploadSuccess', "editSuccess"])

    const selectOptionList = ref(["PayPal","PaymentAsia", "Bank Transfer", "FPS", "WeChat Pay", "Alipay", "Custom"])

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const i18n = inject("i18n")

    const shopCompany = ref({})

    const paymentTitle = ref("")
    const paymentSubTitle = ref("")
    const sremark = ref("")
    const paymentMethod = ref("PayPal")
    const accountLogin = ref("")
    const accountPassword = ref("")
    const handlePercent = ref(0)
    const QRImg = ref(null)

    const loading = ref(false)

    function insertClick() {
        if (myUtil.isEmpty(paymentTitle.value) || myUtil.isEmpty(paymentTitle.value)){
            myUtil.alertWarning("請輸入完整")
            return
        }

        if (myUtil.isEmpty(sremark.value) || myUtil.isEmpty(paymentMethod.value)){
            myUtil.alertWarning("請輸入完整")
            return
        }

        if (myUtil.isEmpty(accountLogin.value) || myUtil.isEmpty(handlePercent.value)){
            myUtil.alertWarning("請輸入完整")
            return
        }

        submitData()
    }

    function updateClick() {
        if (myUtil.isEmpty(paymentTitle.value) || myUtil.isEmpty(paymentTitle.value)){
            myUtil.alertWarning("請輸入完整")
            return
        }

        if (myUtil.isEmpty(sremark.value) || myUtil.isEmpty(paymentMethod.value)){
            myUtil.alertWarning("請輸入完整")
            return
        }

        if (myUtil.isEmpty(accountLogin.value) || myUtil.isEmpty(handlePercent.value)){
            myUtil.alertWarning("請輸入完整")
            return
        }

        saveData()
    }

    function submitData() {
        loading.value = true

        const request = eshopopeeApi.insertPayment
        const params = request.getParams()

        params.CompanyCode = shopCompany.value.acccompanycode
        params.accountLogin = accountLogin.value
        params.handlePercent = handlePercent.value
        params.paymentMethod = paymentMethod.value
        params.paymentSubTitle = paymentSubTitle.value
        params.paymentTitle = paymentTitle.value
        params.sremark = sremark.value
        params.QRImg = QRImg.value

        request.send(params, (res) => {
            loading.value = false
            myUtil.alertSuccess("添加成功")

            paymentTitle.value = ""
            paymentSubTitle.value = ""
            sremark.value = ""
            paymentMethod.value = "PayPal"
            accountLogin.value = ""
            handlePercent.value = 0
            QRImg.value = null
        })
    }

    function saveData() {
        loading.value = true

        const request = eshopopeeApi.updatePayment
        const params = request.getParams()

        myUtil.mergeObj(props.obj, params)

        params.accountLogin = accountLogin.value
        params.handlePercent = handlePercent.value
        params.paymentMethod = paymentMethod.value
        params.paymentSubTitle = paymentSubTitle.value
        params.paymentTitle = paymentTitle.value
        params.sremark = sremark.value
        params.paymentID = props.obj.id
        params.CompanyCode = shopCompany.value.acccompanycode

        if (null != QRImg.value && QRImg.value.indexOf("http") == -1){
            params.QRImg = QRImg.value
        }else{
            params.QRImg = null
        }

        request.send(params, (res) => {
            loading.value = false
            myUtil.alertSuccess("保存成功")
        })
    }

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()

        if (null != props.obj){
            paymentTitle.value = props.obj.paymentTitle
            paymentSubTitle.value = props.obj.paymentSubTitle
            sremark.value = props.obj.sremark
            paymentMethod.value = props.obj.paymentMethod
            accountLogin.value = props.obj.accountLogin
            handlePercent.value = props.obj.handlePercent

            QRImg.value = `${proxy.$SSL}://${proxy.$EShopopeeUrl}/MPic/${shopCompany.value.acccompanycode}/Pa/${props.obj.id.substring(0, 2)}/${props.obj.id}.jpg`
        }
    })
</script>

<style scoped>
    .full-width-edit-material {
        width: 100%;
        list-style: none;
        padding-left: 0;
        text-align: left;
    }

    .full-width-edit-material li {
        margin-bottom: 20px;
    }

    .input-label {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }
</style>